var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSantaHat(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17446_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2067 16.3491L3.48693 13.3345C2.33153 13.0979 1.2089 13.7808 0.989923 14.85L0.541205 17.0411C0.481835 17.331 1.09419 17.8679 2.0207 18.4954C6.5249 21.5541 12.1842 22.7131 17.5282 21.6713C18.6273 21.4564 19.4009 21.2055 19.4603 20.9156L19.909 18.7246C20.128 17.6553 19.3621 16.5857 18.2088 16.3495L18.2067 16.3491Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7649 16.8618C15.407 3.61018 22.672 6.39819 22.672 6.39819L23.5815 5.23832C9.66799 -2.17263 3.97774 10.0402 2.66918 13.5654C7.3229 16.1185 12.6113 17.2825 17.9059 16.92L18.7649 16.8618Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M17.5282 21.6713C18.6273 21.4564 19.4009 21.2055 19.4603 20.9156L19.909 18.7246C20.128 17.6553 19.3621 16.5857 18.2088 16.3495L17.4273 16.1895C16.9141 17.2204 13.4143 22.8206 0.770459 15.9323L0.543303 17.0415C0.483933 17.3314 1.09629 17.8683 2.0228 18.4958C6.527 21.5546 12.1863 22.7136 17.5303 21.6717L17.5282 21.6713Z",
    fill: "#B7B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6577 6.3931C22.6577 6.3931 22.6598 6.39353 22.6619 6.39396C22.6682 6.39526 22.6724 6.39612 22.6724 6.39612L23.582 5.23625C22.8004 4.8201 22.0471 4.46884 21.3176 4.17278C20.976 4.48367 20.6941 4.86591 20.4974 5.30278C17.9262 5.12861 14.7897 6.79548 16.4544 16.9752C16.9376 16.9669 17.4221 16.9523 17.9084 16.9184L18.7675 16.8601C16.7944 9.07312 18.489 6.8264 20.222 6.29483C21.2845 5.9696 22.3592 6.29038 22.6153 6.37567C22.6153 6.37567 22.6174 6.3761 22.6195 6.37653C22.6359 6.38207 22.6481 6.38675 22.6582 6.391L22.6577 6.3931Z",
    fill: "#D81D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0918 9.29682C24.5212 9.58954 25.9172 8.66812 26.2099 7.23876C26.5027 5.80939 25.5812 4.41336 24.1519 4.12064C22.7225 3.82791 21.3265 4.74933 21.0338 6.1787C20.741 7.60806 21.6625 9.00409 23.0918 9.29682Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M24.2392 4.14294C24.6386 4.71503 24.8115 5.4421 24.6605 6.17946C24.3679 7.60795 22.9709 8.53007 21.5424 8.23752C21.513 8.23149 21.4844 8.22127 21.455 8.21525C21.8289 8.75148 22.399 9.15278 23.0922 9.29475C24.5207 9.5873 25.9178 8.66518 26.2104 7.23669C26.5029 5.80819 25.6183 4.47353 24.2392 4.14294Z",
    fill: "#B7B3B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17446_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1801,
    height: 20.0923,
    fill: "white",
    transform: "translate(4.03114) rotate(11.5739)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaHat);
export default __webpack_public_path__ + "static/media/santa-hat.cd116261.svg";
export { ForwardRef as ReactComponent };